import { Component } from '@angular/core';

@Component({
    selector: 'psm-wave-spinner',
    templateUrl: 'waveSpinner.component.html'
})

export class WaveSpinnerComponent { }


// WEBPACK FOOTER //
// ./src/app/components/common/spinners/waveSpinner.component.ts